import { createGlobalStyle } from "styled-components";

// import "normalize.css";
import "./bootstrap-icons.css";
import "./devicon.min.css";
import "./github.css";
import "./colors.css";
import "./icons.css";

const GlobalStyles = createGlobalStyle`
    *, *::after, *::before {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        outline: none;
        background-color: transparent;
        vertical-align: top;
    }

    
    body {
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue",
            Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji",
            "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        background: #f5f7fb;
    }

    *:not(table) {
        border: none;
    }

    input,
    textarea,
    button,
    select,
    a {
        outline: none;
        box-shadow: none;
        border: none;
        background-color: transparent;
    }

    :focus,
    input:focus,
    textarea:focus,
    button:focus,
    select:focus,
    input[required="required"],
    textarea[required="required"] {
        outline: none;
    }

    label {
        user-select: none;
    }
    
    label,
    button {
        cursor: pointer;
    }

    b,
    strong {
        font-weight: 700;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    em {
        font-style: italic;
    }

    sup,
    sub {
        font-size: smaller;
    }

    sub {
        vertical-align: sub;
    }

    sup {
        vertical-align: super;
    }

    ul {
        display: table;
        list-style-type: none;
        font-size: 16px;
    }

    img {
        vertical-align: top;
        border: none;
        max-width: 100%;
        height: auto;
    }

    iframe {
        vertical-align: top;
        max-width: 100%;
        max-height: 100%;
    }
    
    table {
        border-collapse: collapse;
    }

    fieldset {
        border: none;
        font-size: 0;
        letter-spacing: 0;
    }
        
    .container {
        width: 100%;
        margin-right: auto;
        margin-left: auto;
        padding-right: 0.75rem;
        padding-left: 0.75rem;
    }

    
    .my3 {
        margin: 1rem 0;
    }
    
    .x-fs-15 {
        font-size: 15rem;
    }

    .text-white-50 {
        color: rgba(255, 255, 255, 0.5) !important;
    }

    .fw-400 {
        font-weight: 400 !important;
    }

    .blue_link {
        color: #0d6efd;
    }

    .form-control {
        background-color: #f5f7fb;
    }

    .form-control:focus {
        color: #212529;
        background-color: #f5f7fb;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important;
    }


    .js_showNav {
        display: none;
        color: rgba(0, 0, 0, 0.55);
        line-height: 1;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 0.25rem;
        transition: box-shadow 0.15s ease-in-out;
        padding: 4px 12px;
    }

    .js_showNav_icon {
        width: 30px;
        height: 30px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        display: inline-block;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(0, 0, 0, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
    }

    
    @media (min-width: 768px) {
        .x-h-md-100 {
            height: 100% !important;
        }
    }
`;

export default GlobalStyles;
